import {
    FrontendExperimentsResponse,
    Identifiers
} from "@atlassian/feature-gate-node-client-bootstrapper";

export type FeatureGatesBootstrapValues = FrontendExperimentsResponse & {
    identifiers: Identifiers;
};

declare global {
    interface Window {
        featureGateBootstrapValues: FeatureGatesBootstrapValues;
    }
}

export enum StatsigFeatureGateKey {
    BXPSU_2854_CONFLUENCE_PUBLIC_LINK = "bxpsu-2854_confluence_public_link", // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/gates/bxpsu-2854_confluence_public_link
    BXPSU_2930_SITE_PICKER_BXP_UI = "bxpsu-2930_site_picker_bxp_ui", // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/gates/bxpsu-2930_site_picker_bxp_ui
    BXPSU_2831_JIRA_PRICING_REBRAND = "bxpsu-2831-jira-pricing-rebrand" // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/gates/bxpsu-2831-jira-pricing-rebrand
}

export enum StatsigExperimentKey {
    BXPSU_2628_REMOVE_BUNDLES_NONPAID_JSW = "bxpsu-2628-remove-bundles-nonpaid-jsw-signup", // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/bxpsu-2628-remove-bundles-nonpaid-jsw-signup
    WAC_SIGNUP_UPGRADE_PATH = "wac_signup_upgrade_path", // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/wac_signup_upgrade_path
    ATLAS_58859_JSW_FIND_USER_SEG_AND_TEMPLATE_REDESIGN = "jsw-user-seg-and-template-redesign-team-24", // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/jsw-user-seg-and-template-redesign-team-24/setup
    BXPSU_2791_ALLOW_SITE_EXPANSION_EXPERIMENT = "bxpsu-2791-allow-site-expansion-sign-ups" // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/bxpsu-2791-allow-site-expansion-sign-ups
}

// Recommend to prefix cohort names with experiment ticket (ex. expcen-1234_variation-1)
export enum StatsigExperimentCohort {
    UNEXPECTED_FAILURE = "unexpected_failure",
    NOT_ENROLLED = "not_enrolled",
    BXPSU_2628_REMOVE_BUNDLES_NONPAID_JSW_CONTROL = "control",
    BXPSU_2628_REMOVE_BUNDLES_NONPAID_JSW_VARIANT = "bxpsu-2628-remove-bundles",
    WAC_SIGNUP_UPGRADE_PATH_TEST = "test",
    ATLAS_58859_JSW_FIND_USER_SEG_AND_TEMPLATE_REDESIGN_CONTROL = "control",
    ATLAS_58859_JSW_FIND_USER_SEG_AND_TEMPLATE_REDESIGN_TREATMENT = "treatment",
    BXPSU_2791_ALLOW_SITE_EXPANSION_EXPERIMENT_CONTROL = "control",
    BXPSU_2791_ALLOW_SITE_EXPANSION_EXPERIMENT_VARIANT = "bxpsu-2791-allow-site-expansion-signups"
}
